import SvgIcon from './SvgIcon';

const EllipsesIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 39 38">
    <g>
      <g transform="rotate(-180 15 10.5)">
        <circle cx="2.5" cy="2.5" r="2.5" />
        <circle cx="10.5" cy="2.5" r="2.5" />
        <circle cx="18.5" cy="2.5" r="2.5" />
      </g>
    </g>
  </SvgIcon>
);

EllipsesIcon.defaultProps = {
  width: 39,
  height: 39,
};

export default EllipsesIcon;
